import {
    fetchPermissionsBySubproject,
    fetchRolesAssignedToSubproject,
    fetchSpecificUser,
    fetchSubprojectAssigned,
    fetchUserListPermissions,
    fetchUserManagement,
} from './action';

export const userManagementActions = {
    fetchUserManagement,
    fetchUserListPermissions,
    fetchSubprojectAssigned,
    fetchRolesAssignedToSubproject,
    fetchSpecificUser,
    fetchPermissionsBySubproject,
};
